import { api } from '@/services/api/main/axios';

export type ColumnSettingsPreset = {
  id?: string;
  name?: string | null;
  settings: Array<{
    context: string;
    order: unknown;
    columns: Array<{ name: string; width: unknown; totalType?: unknown }>;
  }>;
};

export const getColumnSettingsApiRequest = async (): Promise<ColumnSettingsPreset[]> => {
  const res = await api.get<{ payload: ColumnSettingsPreset[] }>('column-settings');
  return res.data.payload;
};

export const putColumnSettingsApiRequest = async (payload: {
  id: string;
  name?: string | null;
  settings: Array<{
    context: string;
    order: unknown;
    columns: Array<{ name: string; width: unknown; totalType?: unknown }>;
  }>;
}): Promise<unknown> => {
  const res = await api.put<{ payload: unknown }>('column-settings', payload);
  return res.data.payload;
};

export const patchColumnSettingsWidthApiRequest = async (
  payload: Record<string, unknown>,
): Promise<unknown> => {
  const res = await api.patch<{ payload: unknown }>('column-settings/width', payload);
  return res.data.payload;
};

export const patchColumnSettingsOrderApiRequest = async (payload: {
  id: string;
  name?: string;
  settings: unknown[];
}): Promise<unknown> => {
  const res = await api.patch<{ payload: unknown }>('column-settings', payload);
  return res.data.payload;
};

export const deleteColumnSettingsPresetApiRequest = async (id: string): Promise<void> => {
  await api.delete(`column-settings/${id}`);
};
